export default __webpack_public_path__ + "static/media/avasta.d9a08101.ttf";